import * as React from "react";

export type PrevNextPaginationData = {
    loadPrevPage: () => void;
    loadNextPage: () => void;
    hasNextPage: boolean;
    hasPrevPage: boolean;
};

type Props = {
    nextCursor: string | null | undefined;
    fetchPage: (pageCursor?: string | null | undefined) => void;
    children: (result: {
        loadPrevPage: () => void;
        loadNextPage: () => void;
        hasNextPage: boolean;
        hasPrevPage: boolean;
    }) => React.ReactNode;
};

type State = {
    cursorStack: Array<string>;
};

export default class PrevNextPaginationManager extends React.PureComponent<
    Props,
    State
> {
    state: State = {
        cursorStack: [],
    };

    loadNextPage: () => void = () => {
        const {cursorStack} = this.state;
        const {nextCursor, fetchPage} = this.props;
        if (nextCursor) {
            const newCursorStack = [...cursorStack, nextCursor];
            this.setState({cursorStack: newCursorStack});
            fetchPage(nextCursor);
        }
    };

    loadPrevPage: () => void = () => {
        const {cursorStack} = this.state;
        const {fetchPage} = this.props;

        if (cursorStack.length) {
            const newCursorStack = cursorStack.slice(0, -1);
            const prevCursor = newCursorStack[newCursorStack.length - 1];
            this.setState({cursorStack: newCursorStack});
            fetchPage(prevCursor);
        }
    };

    render(): React.ReactNode {
        const loadNextPage = this.loadNextPage;
        const loadPrevPage = this.loadPrevPage;
        const hasNextPage = !!this.props.nextCursor;
        const hasPrevPage = !!this.state.cursorStack.length;
        return this.props.children({
            loadPrevPage,
            loadNextPage,
            hasNextPage,
            hasPrevPage,
        });
    }
}
